/**
 * @generated SignedSource<<b3330c3f36656287c0d63f27d02f7960>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePersistedEmployeeIdRegisterMutation$variables = {
  employeeId: string;
};
export type usePersistedEmployeeIdRegisterMutation$data = {
  readonly storeViewer: {
    readonly registerActivity: {
      readonly __typename: "StoreViewer";
    };
  } | null;
};
export type usePersistedEmployeeIdRegisterMutation = {
  response: usePersistedEmployeeIdRegisterMutation$data;
  variables: usePersistedEmployeeIdRegisterMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "employeeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "SESSION_STARTED"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePersistedEmployeeIdRegisterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreViewerMutation",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreViewer",
            "kind": "LinkedField",
            "name": "registerActivity",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": "registerActivity(type:\"SESSION_STARTED\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePersistedEmployeeIdRegisterMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StoreViewerMutation",
        "kind": "LinkedField",
        "name": "storeViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreViewer",
            "kind": "LinkedField",
            "name": "registerActivity",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": "registerActivity(type:\"SESSION_STARTED\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d628968f27def59bd6babb4607536496",
    "id": null,
    "metadata": {},
    "name": "usePersistedEmployeeIdRegisterMutation",
    "operationKind": "mutation",
    "text": "mutation usePersistedEmployeeIdRegisterMutation(\n  $employeeId: ID!\n) {\n  storeViewer(employeeId: $employeeId) {\n    registerActivity(type: SESSION_STARTED) {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc38cb2973f4fd6c679fd836c2622ece";

export default node;
